module.exports = __webpack_public_path__ + "img/imagemoutdoor.fed26f89.png";